"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Tooltip.scss");
var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
    tooltipRef = _ref.tooltipRef,
    className = _ref.className,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? {
      left: 0,
      top: 0
    } : _ref$position;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CopyableText-PortalWrapper",
    style: {
      left: position.left,
      top: position.top
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('cds-CopyableText-TooltipContent', className),
    ref: tooltipRef
  }, children));
};
exports.Tooltip = Tooltip;